module.exports = __webpack_public_path__ + "img/award (13).23d5d322.jpg";